import { useState, useEffect } from "react";
import { LANGUAGES } from "./translations";

const SUPPORTED = LANGUAGES.map((l) => l.code);

export const detectLang = () => {
  try {
    const stored = localStorage.getItem("reveal_lang");
    if (stored && SUPPORTED.includes(stored)) return stored;
    const nav = (navigator.language || "en").split("-")[0];
    return SUPPORTED.includes(nav) ? nav : "en";
  } catch {
    return "en";
  }
};

export function useLang() {
  const [lang, setLang] = useState(detectLang());
  useEffect(() => {
    const onStorage = () => setLang(detectLang());
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);
  return lang;
}
